import { Injectable } from '@angular/core';
import {EnvironmentService} from "../../../shared/core/services/all-modules-services/environment.service";

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {

  constructor(private env: EnvironmentService) {}

  getEndpointFor(api: string): string {
    return `${this.env.apiBaseUrl()}/${api}`;
  }
}
